import { AcceptPage } from '@/cms/definitions/content-types';
import { DigitalAcceptCmsPage, Policy } from '@/types/types';
import { flattenProductFields } from './FieldService';

export const normalizeModelFromApi = (proposal: DigitalAcceptCmsPage, cmsModel: AcceptPage) => {
	for (const policy of proposal.policies) {
		flattenProductFields(policy);
		mapTypeAndTitle(policy, cmsModel);
		mapDescription(policy);
	}
};

export const mapTypeAndTitle = (policy: Policy, cmsModel: AcceptPage) => {
	const isAcceptPage = cmsModel.contentType === 'AcceptPage';
	const mappedProductType = getProductType(policy);

	if (isAcceptPage) {
		// accept page
		for (const policyRawBlock of cmsModel.adjustPoliciesBlock?.policyBlock?.items || []) {
			if (policyRawBlock.content.type.toLocaleLowerCase() === mappedProductType.toLocaleLowerCase()) {
				policyRawBlock.content.originalType = policy.type;
				policy.type = mappedProductType;
				policy.title = policyRawBlock.content.title;
				break;
			}
		}
	} else {
		// receipt page
		for (const policyBlock of cmsModel?.productNames || []) {
			if (policyBlock.key.toLocaleLowerCase() === mappedProductType.toLocaleLowerCase()) {
				policy.title = policyBlock.value;
				break;
			}
		}
	}

	mapAccidentTitle(policy);
};

const getProductType = (policy: Policy): string => {
	let policyType = policy.type;
	if (policy.type.startsWith('CONTENT')) {
		policyType = 'CONTENT';
	}
	if (policy.type.endsWith('MOPED')) {
		policyType = 'MOPED';
	}
	return policyType;
};

const mapAccidentTitle = (policy: Policy) => {
	if (policy.type === 'ACCIDENT') {
		switch (policy?.policy_object?.accident_insurance_type) {
			case 'ADULT':
				policy.title = 'Voksenulykke';
				break;
			case 'CHILD':
				policy.title = 'Børneulykke';
				break;
			case 'EXTENDED_REPLACEMENT':
				policy.title = 'Udvidet strakserstatning';
				break;
			case 'ASSAULT':
				policy.title = 'Overfald';
				break;
			default:
				break;
		}
	}
};

export const mapDescription = (policy) => {
	// job_title -> accident
	// brand -> trailer
	// coverage_area -> travel 'EUROPE' | 'WORLD*

	switch (policy.type) {
		case 'ACCIDENT':
			policy.description = policy.policy_object?.name;
			// TO BE -> policy.description = policy.policy_object?.job_title;
			break;
		case 'TRAVEL':
			if (policy.policy_object?.coverage_area === 'EUROPE') {
				policy.description = 'Dækker Europa';
			} else if (policy.policy_object?.coverage_area === 'WORLD') {
				policy.description = 'Dækker Verden';
			}
			break;
		case 'TRAILER':
			policy.description = policy.policy_object?.brand;
			break;
	}
};
